/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Card, CardContent, CardHeader, makeStyles } from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
import classNames from 'classnames';
import Alert from '@material-ui/lab/Alert';
import DOMPurify from 'dompurify';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.elementBackground,
    paddingLeft: '3.6rem',
    paddingRight: '3.6rem',
    paddingBottom: '3.6rem',
    maxWidth: '70%',
    boxShadow: 'none',
    borderRadius: '1rem',
  },
  innerContent: {
    background: theme.palette.white,
    borderRadius: '1rem',
  },
  header: {
    paddingTop: '2.3rem',
    '& span': {
      fontWeight: 'bold',
      fontSize: '1.38rem',
    },
  },
  sectionHidden: {
    visibility: 'hidden',
    opacity: 0,
    height: 0,
    transition: 'visibility 0s, opacity 0.5s linear',
  },
  alertInfoContainer: {
    marginTop: '2rem',
    backgroundColor: theme.palette.elementBackground,
  },
  alertWrapper: {
    marginTop: '1.5rem',
  },
}));

export default function StaticCardField(props) {
  const { uiSchema, schema } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const isSectionHidden = uiSchema['ui:hidden'];
  const infoMessage = uiSchema['ui:infoMessage'];

  return (
    <Card className={classNames(classes.root, isSectionHidden && classes.sectionHidden)}>
      <CardHeader title={t(schema.title)} className={classes.header} />
      <CardContent className={classes.innerContent}>
        {uiSchema?.entries?.map((element, index) => (
          <div key={index}>
            <p>
              {element?.key}
              : &nbsp;
              <strong>{element?.value}</strong>
            </p>
          </div>
        ))}
      </CardContent>
      <div id="info">
        {infoMessage && (
          <Alert id="alert-info" variant="outlined" severity="info" className={classes.alertInfoContainer}>
            <Trans i18nKey={infoMessage} />
          </Alert>
        )}
      </div>
      {uiSchema['ui:tooltip']?.position === 'BOTTOM' && (
        <div className={classes.alertWrapper}>
          <Alert severity="info">
            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t(uiSchema['ui:tooltip']?.message)) }} />
          </Alert>
        </div>
      )}
    </Card>
  );
}
